import { MemberDto, PermissionDto } from '@careapp-group/ng-sdk';
import { createAction, props } from '@ngrx/store';

import { CareAppListActionFactory } from '../action-factory';

export interface AddToSpecificCustomerTeamData {
  memberId: string;
  role: string;
  customerId: string;
}

export interface RemoveFromSpecificCustomerTeamData {
  memberId: string;
  customerId: string;
}

class CustomerTeamActions extends CareAppListActionFactory<MemberDto> {
  private get REQUEST_ALL_BY_ID() {
    return `[${this.type}][Request] All by Id`;
  }

  private get REQUEST_REMOVE() {
    return `[${this.type}][Request] Remove`;
  }

  private get RESPONSE_SUCCESS_REMOVE() {
    return `[${this.type}][Response][Success] Remove`;
  }

  private get RESPONSE_FAIL_REMOVE() {
    return `[${this.type}][Response][Fail] Remove`;
  }

  private get REQUEST_CREATE_FOR_CUSTOMER() {
    return `[${this.type}][Request] Create for customer`;
  }

  private get REQUEST_REMOVE_FROM_CUSTOMER() {
    return `[${this.type}][Request] Remove from customer`;
  }

  private get RESPONSE_SUCCESS_CREATE_FOR_CUSTOMER() {
    return `[${this.type}][Response][Success] Create for customer`;
  }

  /**
   * Revoke a user's permissions on the currently selected customer
   *
   * @param {{ id: string }} payload The member id to revoke permissions from
   * @returns
   * @memberof CustomerTeamActions
   */
  RequestRemove = createAction(this.REQUEST_REMOVE, props<{ memberId: string }>());

  ResponseSuccessRemove = createAction(
    this.RESPONSE_SUCCESS_REMOVE,
    props<{ memberId: string; customerId: string }>()
  );

  ResponseFailRemove = createAction(
    this.REQUEST_REMOVE,
    props<{ memberId: string; customerId: string }>()
  );

  // Add the current member to a specific customer, with a role.
  // Looking to use the currently selected customer? Use 'CustomerTeam.RequestCreateAction'.
  RequestCreateForCustomerAction = createAction(
    this.REQUEST_CREATE_FOR_CUSTOMER,
    props<AddToSpecificCustomerTeamData>()
  );

  // Remove the current member from a specific customer
  // Looking to remove the currently selected customer? Use 'CustomerTeam.RequestRemove'.
  RequestRemoveFromCustomerAction = createAction(
    this.REQUEST_REMOVE_FROM_CUSTOMER,
    props<RemoveFromSpecificCustomerTeamData>()
  );

  ResponseSuccessAddMemberToCustomer = createAction(
    this.RESPONSE_SUCCESS_CREATE_FOR_CUSTOMER,
    props<{ permission: PermissionDto }>()
  );

  RequestAllById = createAction(this.REQUEST_ALL_BY_ID, props<{ customerId: string }>());

  constructor() {
    super('CustomerTeam');
  }
}

export const CustomerTeam = new CustomerTeamActions();
